import type { EntityStatus } from '@ms/yammer-data-support';
import { getStatusForId } from '@ms/yammer-data-support';
import createCachedSelector from 're-reselect';

import type { CampaignSponsors, User, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';
import { findUsers } from '../users/selectors';

type GetStatusForCampaignSponsorsId = (state: YammerState, campaignId: CampaignSponsors['id']) => EntityStatus;
export const getStatusForCampaignSponsorsId: GetStatusForCampaignSponsorsId = (state, campaignId) =>
  getStatusForId(state.campaignSponsors, campaignId);

const findCampaignSponsorsById = createFindById('campaignSponsors');
const findCampaignSponsorsByIdThrows = createFindByIdThrows('campaignSponsors');

type GetCampaignSponsors = (state: YammerState, campaignId: CampaignSponsors['id']) => User['id'][] | undefined;
export const getCampaignSponsors: GetCampaignSponsors = createCachedSelector(
  (_state: YammerState, campaignId: CampaignSponsors['id']) => campaignId,
  findCampaignSponsorsById,
  (_campaignId, campaignSponsors) => campaignSponsors?.users.map((sponsor) => sponsor.nodeId)
)((_state, campaignId) => campaignId);

type GetCampaignSponsorsThrows = (state: YammerState, campaignId: CampaignSponsors['id']) => User['id'][];
export const getCampaignSponsorsThrows: GetCampaignSponsorsThrows = createCachedSelector(
  (_state: YammerState, campaignId: CampaignSponsors['id']) => campaignId,
  findCampaignSponsorsByIdThrows,
  (_campaignId, campaignSponsors) => campaignSponsors.users.map((sponsor) => sponsor.nodeId)
)((_state, campaignId) => campaignId);

type GetCampaignSponsorUsersThrows = (state: YammerState, campaignId: CampaignSponsors['id']) => User[];
/**
 * @deprecated PERFORMANCE This returns an array of entity objects and forces the consumer's entire component tree.
 * to re-render if any entities change. Consumers should call `getCampaignSponsorsThrows` and pass a userId to each
 * child component which can then select the specific user fields it needs.
 */
export const getCampaignSponsorUsersThrows: GetCampaignSponsorUsersThrows = (state, campaignId) => {
  const userIds = getCampaignSponsorsThrows(state, campaignId);

  return findUsers(state, userIds);
};
